angular.module('iw.frontyard.string')
    .service('StringHelper', function () {

        class StringHelper {

            static trim(string) {

                if (typeof String.prototype.trim !== 'function') {
                    String.prototype.trim = function () {
                        return this.replace(/^\s+/, '').replace(/\s+$/, '');
                    };
                }

                return string.trim();
            }
        }

        return StringHelper;
    });
